import { render, staticRenderFns } from "./CardSchool.vue?vue&type=template&id=d7be9008&scoped=true&"
import script from "./CardSchool.vue?vue&type=script&lang=js&"
export * from "./CardSchool.vue?vue&type=script&lang=js&"
import style0 from "./CardSchool.vue?vue&type=style&index=0&id=d7be9008&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7be9008",
  null
  
)

export default component.exports